// ModalField.jsx

import React from 'react';

// CSS
import './ModalField.css';

/**
 * ModalField
 * 
 * A simple field component for modals.
 *  
 *
 * @param {ReactNode} children - The children to display inside the field.
 * 
 * @returns {ReactNode} - ModalField.
 */
const ModalField = React.memo(({ children }) => {

    // ----- RENDER ----- //

    return (
        <div className="modal-field-container">
            {children}
        </div>
    );

});

// Dev Tools
ModalField.displayName = 'ModalField';

export default ModalField;
